"use client";

import { useContext, useEffect, useRef } from "react";
import type Lenis from "lenis";
import { LenisContext } from "@/lib/lenis-context";

/**
 * Access the page's Lenis instance. Optionally subscribe to its scroll events.
 *
 *   const lenis = useLenis();
 *   lenis?.scrollTo("#pricing", { offset: -80 });
 *
 *   useLenis(({ velocity }) => { ... });
 */
export function useLenis(onScroll?: (lenis: Lenis) => void) {
  const lenis = useContext(LenisContext);
  const callback = useRef(onScroll);

  useEffect(() => {
    callback.current = onScroll;
  }, [onScroll]);

  useEffect(() => {
    if (!lenis || !callback.current) return;
    return lenis.on("scroll", (instance: Lenis) => callback.current?.(instance));
  }, [lenis]);

  return lenis;
}
